
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./AboutSchool.css";
import aboutUs from "../assets/images/about-us.avif";

const AboutSchool = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".about-school-page .animate-on-scroll"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animation");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px",
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="about-school-page">

      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">

            <h1>
              About <span>Our School</span>
            </h1>

            <p>
              Building knowledge, nurturing values and inspiring
              generations since 1968.
            </p>

            <div className="about-breadcrumb">
              <Link to="/">Home</Link>
              <i className="bi bi-chevron-right"></i>
              <span>About Our School</span>
            </div>

          </div>
        </div>
      </section>

      {/* INTRODUCTION SECTION */}
      <section className="about-intro section-space">
        <div className="container">
          <div className="row align-items-center g-5">

            <div className="col-lg-6">
              <div className="about-visual about-image-wrapper animate-on-scroll animate-left">

                <img
                  src={aboutUs}
                  alt="Air Force School, Vayu Sena Nagar, Nagpur"
                  className="about-us-image"
                />

                <div className="about-year-card">
                  <strong>1968</strong>
                  <span>Established</span>
                </div>

                <div className="about-image-decoration"></div>

              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-intro-content animate-on-scroll animate-right">

                <div className="about-section-heading">
                  <span className="about-label">
                    <i className="bi bi-book-half"></i>
                    About Our Institution
                  </span>

                  <h2>
                    A Tradition of <span>Learning & Excellence</span>
                  </h2>
                </div>

                <p className="about-description">
                  Air Force School, Vayu Sena Nagar, Nagpur, was established
                  in 1968 with the aim of providing quality education through
                  a broad, balanced, and relevant curriculum. Affiliated with
                  the Central Board of Secondary Education (CBSE), the school
                  caters to students from LKG to Class X.
                </p>

                <p className="about-description">
                  We strive to nurture academic excellence, discipline,
                  creativity, and strong moral values among our students.
                  Our focus is on providing a supportive learning environment
                  that encourages critical thinking, holistic development,
                  and lifelong learning.
                </p>

                <p className="about-description">
                  We aim to empower students with the knowledge, skills,
                  and confidence needed to become responsible citizens
                  and contribute positively to society.
                </p>

                <div className="about-highlight">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>
                    A supportive environment for learning and holistic
                    development.
                  </span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SCHOOL HIGHLIGHTS */}
      <section className="about-highlights section-space">
        <div className="container">

          <div className="about-section-heading text-center animate-on-scroll">
            <span className="about-label">
              <i className="bi bi-stars"></i>
              Our Highlights
            </span>

            <h2>
              Learning with <span>Purpose</span>
            </h2>

            <p>
              Creating a strong foundation for every student's future
              through meaningful education.
            </p>
          </div>

          <div className="row g-4 mt-3">

            <div className="col-md-6 col-lg-3">
              <div className="about-highlight-card animate-on-scroll">
                <div className="about-card-icon sky-icon">
                  <i className="bi bi-calendar-check"></i>
                </div>
                <h3>Established 1968</h3>
                <p>
                  A school committed to quality education since
                  its establishment.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="about-highlight-card animate-on-scroll">
                <div className="about-card-icon gold-icon">
                  <i className="bi bi-book-half"></i>
                </div>
                <h3>CBSE Curriculum</h3>
                <p>
                  Education affiliated with the Central Board
                  of Secondary Education.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="about-highlight-card animate-on-scroll">
                <div className="about-card-icon red-icon">
                  <i className="bi bi-mortarboard"></i>
                </div>
                <h3>LKG to Class X</h3>
                <p>
                  Learning opportunities from foundational years
                  through secondary education.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="about-highlight-card animate-on-scroll">
                <div className="about-card-icon black-icon">
                  <i className="bi bi-stars"></i>
                </div>
                <h3>Holistic Growth</h3>
                <p>
                  Encouraging creativity, discipline and strong
                  moral values.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* OUR APPROACH */}
      <section className="about-approach section-space">
        <div className="container">
          <div className="row align-items-center g-5">

            <div className="col-lg-5">
              <div className="about-approach-content animate-on-scroll animate-left">

                <span className="about-label">
                  <i className="bi bi-lightbulb-fill"></i>
                  Our Approach
                </span>

                <h2>
                  Education Beyond <span>Classrooms</span>
                </h2>

                <p>
                  Our focus is on providing a supportive learning
                  environment that encourages critical thinking,
                  holistic development, and lifelong learning.
                </p>

                <p>
                  We aim to empower students with the knowledge,
                  skills, and confidence needed to become responsible
                  citizens and contribute positively to society.
                </p>

              </div>
            </div>

            <div className="col-lg-7">
              <div className="about-approach-grid animate-on-scroll animate-right">

                <div className="approach-item">
                  <span>01</span>
                  <div>
                    <h3>Academic Excellence</h3>
                    <p>
                      Building a strong foundation of knowledge
                      and understanding.
                    </p>
                  </div>
                </div>

                <div className="approach-item">
                  <span>02</span>
                  <div>
                    <h3>Discipline & Values</h3>
                    <p>
                      Developing responsible behaviour and
                      strong moral values.
                    </p>
                  </div>
                </div>

                <div className="approach-item">
                  <span>03</span>
                  <div>
                    <h3>Creativity & Thinking</h3>
                    <p>
                      Encouraging curiosity, creativity and
                      critical thinking.
                    </p>
                  </div>
                </div>

                <div className="approach-item">
                  <span>04</span>
                  <div>
                    <h3>Lifelong Learning</h3>
                    <p>
                      Inspiring students to keep learning,
                      growing and contributing.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

    </main>
  );
};

export default AboutSchool;
